// Responses step copy (spec §9.1, §9.3 Continue, §5.3; 01 §7 messages).

const plural = (n, one, many) => (n === 1 ? one : many);

export const RESPONSES_COPY = Object.freeze({
  heading: 'Upload student responses',
  selectFiles: 'Select files',
  dropFirst: 'or drop the whole class set here',
  kinds: 'Handwritten or typed · PDF, photos, Word',
  dropMore: 'Drop more files here, or',
  browse: 'browse',
  dropMoreDetail:
    'Late scripts, extra pages or photos. Handwritten or typed · PDF, photos, Word',
  files: (n) => `${n} ${plural(n, 'file', 'files')}`,
  uploading: (done, total) => `Uploading ${done} of ${total}…`,
  allUploaded: 'All uploaded',
  uploadNeedsAttention: 'Some files need attention',
  remove: 'Remove',
  retry: 'Retry',
  // File rows (spec §9.1): a signed upload that never completed, and a file
  // the server couldn't read (its error is a code such as PDF_UNREADABLE).
  uploadUnfinished: "Upload didn't finish",
  fileUnreadable: "We couldn't read this file",
  pages: (n) => `${n} ${plural(n, 'page', 'pages')}`,
  annotationQuestion:
    'Do these scripts have marker annotations on any of the pages?',
  annotationHelp:
    "Ticks, comments or marks written on the page. JeddAI will separate them from the student's writing and won't use them when grading.",
  yes: 'Yes',
  no: 'No',
  pasteTyped: '+ Paste a typed response instead',
  pasteTitle: 'Paste a typed response',
  cancel: 'Cancel',
  whichQuestion: 'Which question is this a response to?',
  who: 'Student name or ID',
  responsePlaceholder: "Paste the student's response here",
  words: (n) => `${n} ${plural(n, 'word', 'words')}`,
  addAnother: 'Add and paste another',
  addResponse: 'Add response',
  typedTitle: (n) => `${n} typed ${plural(n, 'response', 'responses')}`,
  // "3 files + 1 typed response" (tplA 833 upSummary).
  filesAndTyped: (files, typed) =>
    `${files} ${plural(files, 'file', 'files')} + ${typed} typed ${plural(
      typed,
      'response',
      'responses'
    )}`,
  // The typed form's count line before anything is pasted (tplA 858).
  typedCountEmpty: 'Each typed response counts as one script',
  typedRow: (words) =>
    words ? `Typed · ${words} ${plural(words, 'word', 'words')}` : 'Typed',
  needWho: "Add the student's name or ID.",
  needText: 'Paste the response.',
  needQuestion: 'Choose the question.',
  addCredits: 'Add credits',
  // Continue (start conversion)
  noFiles: 'Add student responses first.',
  uploadsInProgress: 'Wait for uploads to finish.',
  removeUnfinished:
    "Remove the files that didn't finish uploading, then add them again.",
  annotationRequired: 'Tell us whether the scripts have marker annotations.',
  // FAILED job (spec §9.2): it takes file changes and starts again on the
  // same exam (BE IngestionService idle/startable; 03 §5.3's message).
  conversionFailed: "We couldn't read any of these files.",
  failedHelp: 'Remove the files marked ✕, add others, then Continue.',
  // A refused page Retry during conversion (spec §9.2).
  retryFailed: "We couldn't retry that page. Try again.",
  tryAgain: 'Try again',
  // Check pages Continue (commit)
  notSaved: 'Changes not saved yet. Retry them first.',
  findingStarts: 'Finding where each question starts…',
  creditsNeeded: (n) => `${n} script ${plural(n, 'credit', 'credits')} needed`,
  // No shortfall: a neutral note, not a red validation line.
  creditsCovered: (n, by) =>
    `${n} ${plural(n, 'credit', 'credits')} · covered by ${by}`,
  coveredByFree: 'your free exam',
  coveredByFreeAndBalance: 'your free exam and balance',
  coveredByBalance: 'your balance',
  // Marking started (spec §9.3, Mark for me)
  markingMfm: (done, total) =>
    `JeddAI is marking and ranking every script · ${done} of ${total}`,
  markingMfmPct: (pct) =>
    `JeddAI is marking and ranking every script · ${pct}%`,
  markingStarted: 'Marking has started',
  markingDoubleBody:
    'JeddAI is marking in the background. Add your marks next.',
  toYourMarks: 'Go to Your marks',
  toSamples: 'Go to Samples',
  loading: 'Loading responses…',
  loadFailed: "We couldn't load the responses.",
});
